import React from 'react';
import AppCommonLayout from './AppCommonLayout';

export default function LoggedInUserWrapper({ children, welcomeMode = false, testMode = false, ...otherProps }) {
  return (
    <div className="flex h-full max-h-svh w-full min-h-0 flex-col overflow-hidden bg-white">
      <AppCommonLayout welcomeMode={welcomeMode} testMode={testMode} {...otherProps}>
        {children}
      </AppCommonLayout>
    </div>
  );
}